var Level;
(function (Level) {
    Level["ASSERTIVE"] = "assertive";
    Level["POLITE"] = "polite";
})(Level || (Level = {}));
var liveAnnounceId = 'uitk-live-announce';
var findOrCreateContainer = function (id, ref) {
    var _a, _b;
    var container = document.createElement('div');
    container.id = id || liveAnnounceId;
    var refParentNode = ref ? (_a = document.body.querySelector("#".concat(id))) === null || _a === void 0 ? void 0 : _a.parentNode : undefined;
    var bodyParentNode = (_b = document.body.querySelector("#".concat(liveAnnounceId))) === null || _b === void 0 ? void 0 : _b.parentNode;
    // Use existing live-announce div in ref container
    if (refParentNode) {
        return refParentNode.querySelector("#".concat(id));
    }
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
        // Create new live-announce div in ref container
        return ref.current.appendChild(container);
    }
    // Use existing live-announce container at bottom of page
    if (bodyParentNode) {
        return document.body.querySelector("#".concat(liveAnnounceId));
    }
    // Create new live-announce at bottom of page
    return document.body.appendChild(container);
};
// Ref and Id added to fix Dialog Typeahead
// not seeing live announce
// https://jira.expedia.biz/browse/WCAG-10081
var liveAnnounce = function (msg, level, className, ref, id) {
    if (msg === void 0) { msg = ''; }
    if (level === void 0) { level = Level.ASSERTIVE; }
    if (className === void 0) { className = 'is-visually-hidden'; }
    // If no browser, exit early
    /* istanbul ignore if */
    if (!(typeof document !== 'undefined' && typeof document.querySelector === 'function')) {
        return;
    }
    // Find it or create it
    var liveRegion = findOrCreateContainer(id, ref);
    // Clear out exist contents so they are not read
    liveRegion.textContent = '';
    liveRegion.setAttribute('aria-live', level);
    liveRegion.setAttribute('class', className);
    liveRegion.textContent = msg;
};

export { Level, liveAnnounce };
